import { render, staticRenderFns } from "./turnover.vue?vue&type=template&id=3eafa16c"
import script from "./turnover.vue?vue&type=script&lang=js"
export * from "./turnover.vue?vue&type=script&lang=js"
import style0 from "./turnover.vue?vue&type=style&index=0&id=3eafa16c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports